import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setAssignDeleteError, setLoading } from "../../repository/slice";

function* removeAllAssignWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.delete, "/api/assign/all", payload);
        if (isError) {
            yield put(setAssignDeleteError(message));
        } else {
            yield put(setAssignDeleteError(null));
        }
    } catch (error) {
        console.error("removeAllAssignWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* removeAllAssignWatcher() {
    yield takeLatest("@saga/DELETE_ALL_ASSIGN", removeAllAssignWorker);
};